var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPath15225(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.984,
    height: 19,
    viewBox: "0 0 13.984 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15225",
    "data-name": "Path 15225",
    d: "M75.641,4.69V4.049a4.049,4.049,0,1,0-8.1,0V4.69H64.6V16.445A2.557,2.557,0,0,0,67.155,19H76.03a2.557,2.557,0,0,0,2.555-2.555V4.69Zm-7.1,2.982a.858.858,0,1,1,.858-.858A.858.858,0,0,1,68.541,7.671ZM73.774,4.69H69.41V4.049a2.182,2.182,0,0,1,4.364,0Zm.87,2.982a.858.858,0,1,1,.858-.858A.858.858,0,0,1,74.644,7.671Z",
    transform: "translate(-64.6)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath15225);
export default __webpack_public_path__ + "static/media/Path 15225.16302baa589c174c84353c4b648fabe2.svg";
export { ForwardRef as ReactComponent };